export enum PoliciesPagesType {
  General = 'general',
  PrivacyNotice = 'privacy-notice',
  OnlinePrivacyPolicy = 'online-privacy-policy',
  TermsOfUse = 'terms-of-use',
  ConsentForElectronicSignatures = 'consent-for-electronic-signatures',
  Disclosures = 'disclosures',
}
